<template>
  <v-app>
    <Sidebar />
      <v-content>
        <v-container fluid>

          <Menu v-if="status === 'success'" />

          <router-view v-if="user" :key="$route.fullPath">
          </router-view>

          <!--
          <div v-if="status === 'success'">
            logged in
          </div>
          <div v-else>
            <v-layout fill-height justify-center align-space-around row text-xs-center>
              <v-flex class="mt-4">
                <v-progress-circular
                  indeterminate
                >
                </v-progress-circular>
              </v-flex>
            </v-layout>
          </div>
          -->

        </v-container>

        <v-snackbar
          v-model="snackbarIsOpen"
          :color="snackbarColor"
          :timeout="snackbarTimeout"
        >
          {{ snackbarMessage }}
          <v-btn
            dark
            flat
            @click="hideSnackbar"
          >
          close
          </v-btn>
        </v-snackbar>
      </v-content>
  </v-app>
</template>

<script>
import Sidebar from './components/base/sidebar.vue'
import Menu from './components/base/menu.vue'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    Sidebar,
    Menu
  },
  computed: {
    ...mapState('userAuth', [
      'user',
      'status'
    ]),
    ...mapState('global',
      {
        snackbarMessage: state => state.snackbar.message,
        snackbarColor: state => state.snackbar.color,
        snackbarTimeout: state => state.snackbar.timeout,
      }
    ),
    snackbarIsOpen: {
      get: function() {
        return this.$store.state.global.snackbar.isOpen
      },
      set: function(open) {
        if(!open) {
          this.$store.dispatch('global/hideSnackbar')
        }
      }
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
  },
  data: function () {
     return {
     }
  },
  methods: {
    ...mapActions('global', [
      'hideSnackbar'
    ]),
    fetchData () {
      if (this.user.id) {
        this.$store.dispatch('menu/getInitialData').finally(res => {
        })
      }
    }
  },
}
</script>

<style scoped>
</style>
